export const STAT_CATEGORIES = {
    defenders: [
        {
            type: 'average',
            key: 'dreamTeamPoints'
        },
        {
            type: 'average',
            key: 'disposals'
        },
        {
            type: 'average',
            key: 'marks'
        },
        {
            type: 'average',
            key: 'tackles'
        },
        {
            type: 'average',
            key: 'totalClearances'
        }
    ],
    midfielders: [
        {
            type: 'average',
            key: 'dreamTeamPoints'
        },
        {
            type: 'total',
            key: 'goals'
        },
        {
            type: 'total',
            key: 'goalAccuracy'
        },
        {
            type: 'average',
            key: 'marks'
        },
        {
            type: 'average',
            key: 'scoreInvolvements'
        }
    ],
    forwards: [
        {
            type: 'average',
            key: 'dreamTeamPoints'
        },
        {
            type: 'average',
            key: 'disposals'
        },
        {
            type: 'average',
            key: 'pressureActs'
        },
        {
            type: 'average',
            key: 'tackles'
        },
        {
            type: 'average',
            key: 'metresGained'
        }
    ]
};
